import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle.jsx';

import { useApplication } from '../AppContext';

const Achievements = () => {
	const app = useApplication();
	const { t } = useTranslation();

	const allAchievements = React.useMemo(() => {
		const usersAchievements = app.userdata.achievements || [];
		const allAchievements = app.achievements.allAchievements;

		for (const achievement of allAchievements) {
			if (usersAchievements.indexOf(achievement.name) !== -1) {
				achievement.owned = true;
			}
		}

		return allAchievements;
	}, [app.achievements.allAchievements, app.userdata.achievements]);

	const { earned, total } = React.useMemo(() => {

		const earned = allAchievements.filter((achievement) => achievement.owned).length;
		const total = allAchievements.length;
		return {
			earned,
			total,
		};
	}, [allAchievements]);

	return (

		<div id="Achievements1" className="page noAnimate paddingTop50">
			<div className="wrapper">
				<PageTitle>
					<h1>{t('Achievements')}</h1>
				</PageTitle>

				<ul data-model="achievements" data-template="achievement" className="achievementList">
					{allAchievements.map((achievement) => (
						<li
							key={achievement.name}
							className={classnames(!achievement.owned && 'notFound', achievement.isHidden === 'true' ? 'isHidden' : '')}
						>
							<i className={`achievement-${achievement.image}`} />
							<div className='points' data-inner-text="points">{achievement.points}</div>
							<div className='title' data-inner-text="title">{t(achievement.title)}</div>
							<div className='description' data-inner-text="description">{t(achievement.description)}</div>
						</li>
					))}
				</ul>
				<div style={{
					textAlign: 'center',
				}}>
					{earned} / {total}
				</div>
			</div>
		</div>
	);
};

export default Achievements;
